import { get } from 'lodash'
import requestWithRetry from 'civic-champs-shared/api/requestWithRetry'

import { clearManagedOrgOverride, readManagedOrgOverride } from './managedOrgOverride'

export default async function resolveCurrentOrganization(user, tokenOrgId) {
  const overrideOrgId = readManagedOrgOverride(get(user, 'cognitoSub'))

  if (overrideOrgId != null && overrideOrgId !== tokenOrgId) {
    try {
      return await requestWithRetry({ url: `/organizations/${overrideOrgId}` })
    } catch (error) {
      if (get(error, 'message') !== 'Network Error') {
        clearManagedOrgOverride()
      }
    }
  }

  return tokenOrgId ? requestWithRetry({ url: `/organizations/${tokenOrgId}` }) : null
}
